export default "__VITE_ASSET__CV10HWco__"